import React, { useRef } from 'react'
import { Link } from 'gatsby'
import classNames from 'classnames'

import { ReactComponent as TivityLogo } from 'src/media/images/tivity-logo-white.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { clientConfig } from 'src/data/whiteLabelData.js'
import { IS_BROWSER } from '../../../../localConstants'
import styles from './styles.module.scss'
import { useWhiteLabelContext } from '../../../../providers/WhiteLabelProvider'

const Header = ({ className, isTransparent = false, ...props }) => {
  const { client } = useWhiteLabelContext()
  const logoRef = useRef()
  return (
    <header
      className={classNames(className, styles.header, {
        [styles.isTransparent]: isTransparent,
      })}
      {...props}
    >
      <div className={styles.headerContent}>
        <div
          data-track="Header - Logo"
          className={styles.logoWrapper}
          // Set max-width so the container slides over
          // with CSS rather than abruptly jerks
          style={
            IS_BROWSER && logoRef.current
              ? { maxWidth: logoRef.current.offsetWidth + 20 }
              : undefined
          }
        >
          {/* SVGR (i think) wigs out and swaps the contents
          of the svg logos, leaving behind the original SVG viewBox
          and making any theme logos too small/big, so we have to
          only render it in the browser for now */}
          {IS_BROWSER && (
            <div ref={logoRef}>
              {!client && <TivityLogo />}
              {client && clientConfig[client].logo}
            </div>
          )}
        </div>
        <nav className={styles.nav}>
          <ul className={styles.navList}>
            <li>
              <Link to="/on-demand/" activeClassName={styles.activeLink}>
                <span>
                  <FontAwesomeIcon icon="play-circle" /> On-Demand
                </span>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}

export default Header
